export default __webpack_public_path__ + "static/media/history.dac75965.svg";